import React from 'react';
import styled from '@emotion/styled';

export const NavSubHeader = styled.div`
  font-size: 12px;
  color: rgba(0, 0, 0, 0.25);
  margin-left: 32px;
`;
